import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const data = [
  { month: 'Aug', median: 2650 },
  { month: 'Sep', median: 2700 },
  { month: 'Oct', median: 2720 },
  { month: 'Nov', median: 2780 },
  { month: 'Dec', median: 2760 },
  { month: 'Jan', median: 2810 },
  { month: 'Feb', median: 2850 },
];

const MarketTrends = () => {
  return (
    <div className="bg-card rounded-xl border border-border p-6">
      <h3 className="text-lg font-semibold text-foreground mb-1">Suburb Price Trend</h3>
      <p className="text-sm text-muted-foreground mb-4">Mosman NSW — Median sale price (AUD thousands)</p>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
          <XAxis dataKey="month" tick={{ fill: '#888', fontSize: 12 }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fill: '#888', fontSize: 12 }} axisLine={false} tickLine={false} domain={['auto', 'auto']} tickFormatter={v => `$${v}k`} />
          <Tooltip
            contentStyle={{ background: '#1a1a2e', border: '1px solid #333', borderRadius: 8, color: '#fff' }}
            formatter={(v) => [`$${v}k`, 'Median']}
          />
          <Line type="monotone" dataKey="median" stroke="#00D4FF" strokeWidth={2} dot={{ fill: '#00D4FF', r: 4 }} />
        </LineChart>
      </ResponsiveContainer>
      <div className="mt-3 flex items-center gap-2">
        <span className="text-green-400 font-semibold text-sm">↑ 7.5%</span>
        <span className="text-sm text-muted-foreground">6-month growth in this suburb</span>
      </div>
    </div>
  );
};

export default MarketTrends;
